import { useMutation } from 'react-query';
import { workExperienceServices } from 'services/cv';

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';
import Modal from '@core/components/Modal/Modal';

import LinkButton from '@core/components/linkbutton/LinkButton';
import ActionButton from '@core/components/actionbutton/ActionButton';

import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import { beautifyDate } from 'utils/dateUtils';

import EditIcon from 'assets/icons/edit-icon-filled.svg?url';
import AddIcon from 'assets/icons/add-square-icon.svg?url';
import DeleteIcon from 'assets/icons/trash-icon.svg?url';
import { Briefcase } from 'iconsax-react';

import classes from './WorkExperiences.module.scss';

const WorkExperiences = ({ data, refetchMyResume, hasEditButton = false, editClickHandler, isNewStep = true }) => {
	const { destroyModal, show, showModal } = UseModal();
	const { ToastContainer, toast } = UseToast();

	const { mutate: deleteWorkExperience } = useMutation(workExperienceServices.DELETE, {
		onSuccess: () => {
			refetchMyResume();
			toast('Work experience deleted successfully');
		},
		onError: () => {
			toast('Something went wrong! please try again.');
		}
	});

	const deleteWorkExperienceHandler = (id) => {
		deleteWorkExperience(id);
	};

	return (
		<>
			<ToastContainer />
			{((data && data.work_experiences?.length > 0) || isNewStep ) && (
				<section className={`d-flex flex-column gap-2 ${classes['work-experience-wrapper']}`}>
					<div
						className={`d-flex flex-row  justify-content-between ${classes['work-experience-title']}`}>
						<div className='d-flex align-items-center gap-2 ms-4'>
							<Briefcase />
							<h4 className="d-none d-md-block">Work Experience</h4>
						</div>
						{hasEditButton &&
							<div className="d-flex gap-1">
								<ActionButton kind="simple" onClick={() => editClickHandler('work_experience_new')}>
									<img src={AddIcon} alt="add-icon" />
								</ActionButton>
								<ActionButton kind="simple" onClick={() => editClickHandler('work_experience')}>
									<img src={EditIcon} alt="edit-icon" />
								</ActionButton>
							</div>
						}
					</div>
					<div className={`d-flex flex-column gap-4 ${classes['work-experience-content']}`}>
						<>
							{data?.work_experiences?.map((we) => {
								return (
									<div key={we.id} className={classes['work-experience-card']}>
										<div
											className={`d-flex flex-column flex-md-row justify-content-between align-items-baseline align-items-md-center`}>
											<div className="d-flex flex-column gap-2 order-2 order-md-1">
												<h6>{we.job_title}</h6>
												<p>{we.company_name}</p>
												<span>{we.employment_status?.status}</span>
												{we.start_date && (
													<span>{beautifyDate(we.start_date)} - {we.is_currently_employed ? 'Now' : beautifyDate(we.end_date)}</span>
												)}

											</div>
											<span className="order-1 order-md-2 align-self-end align-self-md-center">
												{we.industry}
											</span>
										</div>
										<p className={classes['description']}>{we.description}</p>
									</div>
								);
							})}
						</>
					</div>
				</section>
			)}
			<Modal
				title={'Edit Work Experience'}
				show={show}
				closeHandler={destroyModal}
				type={MOBILE_SLIDE_UP}>
				<div className={`d-flex flex-column gap-4 ${classes['work-experience-content-modal']}`}>
					{data && data.work_experiences.map((we) => {
						return (
							<div
								key={we.id}
								className={`d-flex flex-column flex-md-row justify-content-between ${classes['work-experience-card-modal']}`}>
								<div
									className={`order-2 order-md-1 d-flex flex-column flex-md-row justify-content-between align-items-baseline align-items-md-center flex-grow-1  ${classes['work-experience-card-modal_content']}`}>
									<div className={`d-flex flex-column gap-2 order-2 order-md-1`}>
										<h6>{we.job_title}</h6>
										<p>{we.company_name}</p>
										<span>{we.employment_status?.status}</span>
									</div>
									<span className="order-1 order-md-2 align-self-end align-self-md-center">
										{we.industry}
									</span>
								</div>
								<div
									className={`order-1 order-md-2 d-flex flex-row align-self-end align-self-md-center ${classes['work-experience-card-modal_actions']}`}>
									<ActionButton kind="simple" onClick={() => deleteWorkExperienceHandler(we.id)}>
										<img src={DeleteIcon} alt="delete-icon" />
									</ActionButton>
									<LinkButton kind="simple" to={`/profile/my-resume/work-experience/${we.id}`}>
										<img src={EditIcon} alt="edit-icon" />
									</LinkButton>
								</div>
							</div>
						);
					})}
					<LinkButton to={`/profile/my-resume/work-experience/new`}>
						+ Add another Work experience
					</LinkButton>
				</div>
			</Modal>
		</>
	);
};

export default WorkExperiences;
